"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomHeader = void 0;
var CustomHeader;
(function (CustomHeader) {
    CustomHeader["OperationName"] = "x-operation-name";
})(CustomHeader = exports.CustomHeader || (exports.CustomHeader = {}));
